import {
  Component,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiCallService } from '../../../Services/api-call-service.service';
import { ErrorhandlingService } from '../../../Services/error-handling.service';
import { GameCard } from '../../../Interfaces/interfaces';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LoaderService } from '../../../Services/loader-service.service';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  TabNavigationComponent,
  TabItem,
} from '../../../components/tab-navigation/tab-navigation.component';
import { UtilsService } from '../../../Services/utils.service';
import { LotteryCardComponent } from '../../lottery/lottery-card/lottery-card.component';
import { LotteryCardsComponent } from '../../../components/lottery-cards/lottery-cards.component';
import { SectrechCardListComponent } from '../../../dashboard/Sectrech Cards/sectrech-card-list/sectrech-card-list.component';
import { LotteryWinnersComponent } from '../lottery-winners/lottery-winners.component';
import { LotteryLandingComponent } from '../lottery-landing/lottery-landing.component';
import { GamePromoBannerComponent } from '../game-promo-banner/game-promo-banner.component';
import { LandingCaroselComponent } from '../landing-carosel/landing-carosel.component';
import { ShiningStarsOfGamesComponent } from '../shining-stars-of-games/shining-stars-of-games.component';
import { CmaxGamesComponent } from '../cmax-games/cmax-games.component';
import { OnBoardingStepsComponent } from '../on-boarding-steps/on-boarding-steps.component';
import { SpinComponent } from '../spin/spin.component';
import { AboutUsComponent } from '../about-us/about-us.component';
import { JoinCommunityComponent } from '../join-community/join-community.component';
import { filter, Subscription } from 'rxjs';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { GameService } from '../../../Services/game.service';
import { LotteryListComponent } from '../../Lottery-Module/lottery-list/lottery-list.component';
import { LoginComponent } from '../../login/login.component';

@Component({
  selector: 'app-games-landing',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgFor,
    FontAwesomeModule,
    RouterModule,
    TabNavigationComponent,
    LotteryCardsComponent,
    SectrechCardListComponent,
    LotteryWinnersComponent,
    LotteryLandingComponent,
    CmaxGamesComponent,
    OnBoardingStepsComponent,
    SpinComponent,
    JoinCommunityComponent,
    AboutUsComponent,
    SpinnerComponent,
    LotteryListComponent,
    LoginComponent,
  ],
  templateUrl: './games-landing.component.html',
  styleUrl: './games-landing.component.scss',
})
export class GamesLandingComponent {
  scoreForm!: FormGroup;
  scoreCaptchaForm!: FormGroup;
  showLoginModal: boolean = false;
  searchTerm: string = '';
  selectedMainTab: string = 'games';
  isLandingPage: boolean = true;
  // selectedLotteryTab: string = 'lotteries';

  mainTabs: TabItem[] = [
    { id: 1, label: 'Games', value: 'games', scrollingId: 'games-scroll-id' },
    {
      id: 2,
      label: 'Quick Games',
      value: 'quick',
      scrollingId: 'quick-scrolling-id',
    },
    {
      id: 3,
      label: 'Lotteries',
      value: 'lotteries',
      scrollingId: 'lottriesScrollSection',
    },
    {
      id: 4,
      label: 'Scratch Cards',
      value: 'scratch-cards',
      scrollingId: 'scratchScrollSection',
    },
    { id: 5, label: 'Spin', value: 'spin', scrollingId: 'spin-scrolling-id' },
  ];

  displayMainTabs: TabItem[] = [];

  lotteryTab: TabItem[] = [{ id: 2, label: 'Lotteries', value: 'lotteries' }];

  ScratchTab: TabItem[] = [
    { id: 3, label: 'Scratch Cards', value: 'Scratch Cards' },
  ];

  SpinnerTab: TabItem[] = [
    { id: 4, label: 'Spin', value: 'spin', scrollingId: 'spin-scrolling-id' },
  ];

  QuickgameTab: TabItem[] = [
    {
      id: 1,
      label: 'Quick Games',
      value: 'quick',
      scrollingId: 'quick-scrolling-id',
    },
  ];


  // quickGames: any[] = [
  //   {
  //     id: 5,
  //     name: 'Aviator',
  //     lookup: 'aviator',
  //     image: 'Images/Avaitar.png',
  //     redirectLink: '/dashboard/Avaitar',
  //     bgclr: '#00dbde',
  //     color2: '#00a0a0',
  //     color3: '#004a4a',
  //     bonus: 0,
  //     isHot: false,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 6,
  //     name: 'Baccarat',
  //     lookup: 'bacchrat',
  //     image: 'Images/Baccarat.png',
  //     redirectLink: '/dashboard/Baccaret',
  //     bgclr: '#7c3aed',
  //     color2: '#6d28d9',
  //     color3: '#5b21b6',
  //     bonus: 0,
  //     isHot: false,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 4,
  //     name: 'Treasure',
  //     lookup: 'Treasure',
  //     image: 'Images/treasure-vault.png',
  //     redirectLink: '/dashboard/TreasurePick',
  //     bgclr: '#f59e0b',
  //     color2: '#d97706',
  //     color3: '#b45309',
  //     bonus: 0,
  //     isHot: true,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 8,
  //     name: 'Mines',
  //     lookup: 'Mines',
  //     image: '/bomb.png',
  //     redirectLink: '/dashboard/Mines',
  //     bgclr: '#ef4444',
  //     color2: '#dc2626',
  //     color3: '#b91c1c',
  //     bonus: 0,
  //     isHot: false,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 9,
  //     name: 'Plinko',
  //     lookup: 'Plinko',
  //     image: '/plinko.png',
  //     redirectLink: '/dashboard/Plinko',
  //     bgclr: '#ec4899',
  //     color2: '#db2777',
  //     color3: '#be185d',
  //     bonus: 0,
  //     isHot: false,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 7,
  //     name: 'Roulette',
  //     lookup: 'roulette',
  //     image: '/Rouleet.png',
  //     redirectLink: '/dashboard/Roulette',
  //     bgclr: '#06b6d4',
  //     color2: '#0891b2',
  //     color3: '#0e7490',
  //     bonus: 0,
  //     isHot: false,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 1,
  //     name: 'Spin',
  //     lookup: 'spinner',
  //     image: 'Images/spin.png',
  //     redirectLink: '/dashboard/spinner',
  //     bgclr: '#10b981',
  //     color2: '#059669',
  //     color3: '#047857',
  //     bonus: 0,
  //     isHot: true,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 11,
  //     name: 'Kino',
  //     lookup: 'kino',
  //     image: 'Images/keno.png',
  //     redirectLink: '/dashboard/Keno',
  //     bgclr: '#3b82f6',
  //     color2: '#2563eb',
  //     color3: '#1d4ed8',
  //     bonus: 0,
  //     isHot: false,
  //     buttonText: 'Play'
  //   },
  //   {
  //     id: 3,
  //     name: 'Scratch',
  //     lookup: 'scratch',
  //     image: 'Images/sactrach.png',
  //     redirectLink: '/dashboard/SectrechCards',
  //     bgclr: '#f97316',
  //     color2: '#ea580c',
  //     color3: '#c2410c',
  //     bonus: 0,
  //     isHot: false,
  //     buttonText: 'Play'
  //   },
  // ];
  // redirectTo(link: string) {
  //   if (link.startsWith('http')) {
  //     window.open(link, '_blank');
  //   } else {
  //     this.router.navigate([link]);
  //   }
  // }
  quickGames: any[] = [
    {
      id: 5,
      name: 'Aviator',
      lookup: 'aviator',
      image: 'Images/Avaitar.png',
      redirectLink: '/dashboard/Avaitar',
      bgclr: '#00E5FF',
      color2: '#00B8D4',
      color3: '#006064',
      bonus: 0,
      isHot: false,
      buttonText: 'Play'
    },
    {
      id: 6,
      name: 'Baccarat',
      lookup: 'bacchrat',
      image: 'Images/Baccarat.png',
      redirectLink: '/dashboard/Baccaret',
      bgclr: '#A855F7',
      color2: '#7E22CE',
      color3: '#4C1D95',
      bonus: 0,
      isHot: false,
      buttonText: 'Play'
    },
    {
      id: 4,
      name: 'Treasure',
      lookup: 'Treasure',
      image: 'Images/treasure-vault.png',
      redirectLink: '/dashboard/TreasurePick',
      bgclr: '#FFD54F',
      color2: '#F59E0B',
      color3: '#B45309',
      bonus: 0,
      isHot: true,
      buttonText: 'Play'
    },
    {
      id: 8,
      name: 'Mines',
      lookup: 'Mines',
      image: '/bomb.png',
      redirectLink: '/dashboard/Mines',
      bgclr: '#FF5252',
      color2: '#E53935',
      color3: '#8B0000',
      bonus: 0,
      isHot: false,
      buttonText: 'Play'
    },
    {
      id: 9,
      name: 'Plinko',
      lookup: 'Plinko',
      image: '/plinko.png',
      redirectLink: '/dashboard/Plinko',
      bgclr: '#FF4FA3',
      color2: '#EC4899',
      color3: '#9D174D',
      bonus: 0,
      isHot: false,
      buttonText: 'Play'
    },
    {
      id: 7,
      name: 'Roulette',
      lookup: 'roulette',
      image: '/Rouleet.png',
      redirectLink: '/dashboard/Roulette',
      bgclr: '#38BDF8',
      color2: '#0284C7',
      color3: '#075985',
      bonus: 0,
      isHot: false,
      buttonText: 'Play'
    },
    {
      id: 1,
      name: 'Spin',
      lookup: 'spinner',
      image: 'Images/spin.png',
      redirectLink: '/dashboard/spinner',
      bgclr: '#34D399',
      color2: '#10B981',
      color3: '#065F46',
      bonus: 0,
      isHot: true,
      buttonText: 'Play'
    },
    {
      id: 11,
      name: 'Kino',
      lookup: 'kino',
      image: 'Images/keno.png',
      redirectLink: '/dashboard/Keno',
      bgclr: '#60A5FA',
      color2: '#2563EB',
      color3: '#1E3A8A',
      bonus: 0,
      isHot: false,
      buttonText: 'Play'
    },
    {
      id: 3,
      name: 'Scratch',
      lookup: 'scratch',
      image: 'Images/sactrach.png',
      redirectLink: '/dashboard/SectrechCards',
      bgclr: '#FB923C',
      color2: '#F97316',
      color3: '#9A3412',
      bonus: 0,
      isHot: false,
      buttonText: 'Play'
    }
  ];
  redirectTo(game: any) {
    if (!this.isToken) {
      this.showLoginModal = true;
      return;
    }
    // 1. Handle external links
    if (game.redirectLink.startsWith('http')) {
      window.open(game.redirectLink, '_blank');
      return;
    }
    // 2. Retrieve and parse data from LocalStorage
    const storedGames = JSON.parse(localStorage.getItem('bis_offer') || '[]');
    // 3. Find the specific game in the stored array
    // Ensure the name in quickGames matches the GameName in your local storage
    const gameStatus = storedGames.find((g: any) => g.GameName === game.lookup);
    // 4. Check if game is on update
    if (gameStatus && gameStatus.IsOnUpdate === 'True') {
      // Show error (e.g., Alert, Snackbar, or Toast)
      this.errorHandling.showAlert(
        'warning',
        'Game is under update!. Please try again later.',
      );
      return;
    }

    // 5. If everything is fine, proceed to navigate
    this.router.navigate([game.redirectLink]);
  }

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private apiCallService: ApiCallService,
    private errorHandling: ErrorhandlingService,
    private _loaderService: LoaderService,
    private fb: FormBuilder,
    private gameService: GameService,
    private breakpointObserver: BreakpointObserver,
    private _utilsService: UtilsService,
  ) {
    this.isLandingPage = this.router.url === '/';

    this.routeSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkCurrentRoute();
      });

    // Run once initially
    this.checkCurrentRoute();
    this.filterGames = [...this.allGames];
  }
  AddCaptchaPlayerModal: boolean = false;
  CloseCaptchaAddPlayer() {
    this.AddCaptchaPlayerModal = false;
    this.NewPlayerAddPayload.login_pwd = '';
    this.NewPlayerAddPayload.check_pwd = '';
    this.NewPlayerAddPayload.t = 0;
    this.NewPlayerAddPayload.account = '';
    this.NewPlayerAddPayload.agentcode = '';
  }
  get filteredGames() {
    return this.games.filter((game: any) => {
      const matchesSearch =
        !this.searchTerm ||
        game.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        game.provider
          .toString()
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());

      return matchesSearch;
    });
  }

  filterGames: any[] = [];
  allGames: any[] = []; // sab games
  onSearch(): void {
    const term = this.searchTerm.trim().toLowerCase();

    if (term === '') {
      // agar search empty hai to sab games wapas show karo
      this.filterGames = [...this.allGames];
    } else {
      // otherwise filter karo by name
      this.filterGames = this.allGames.filter((game) =>
        game.name.toLowerCase().includes(term),
      );
    }

    // search hone ke baad showAllGames reset kar do (taake limit se start ho)
    this.showAllGames = false;
  }

  games: any[] = [];

  private routeSub!: Subscription;
  ngOnInit() {
    // this.scoreCaptchaForm = this.fb.group({
    //   captchaCode: ['', Validators.required],
    // });

    this.games = this.gameService.getGames();
    // if (
    //   this._loaderService.getArrayInLocalStorage() &&
    //   this._loaderService.getArrayInLocalStorage()?.length > 0
    // ) {
    //   this.gameAccounts = this._loaderService.getArrayInLocalStorage();
    // } else
    this.getGameNews();
    if (this.isToken) {
      this.getGameAccount(0);
    }
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result: any) => {
        this.isMobileScreen = result.matches;
        this.updateDisplayedTabs();
      });
    this.games.forEach((game: any) => {
      const getPlayerGames = this._loaderService.getArrayInLocalStorage();
      const matchedGame = getPlayerGames.find(
        (matchingGame: any) => matchingGame.GameName === game.name,
      );
      game.buttonText = matchedGame
        ? 'Play Now'
        : game.IsOnUpdate
          ? 'On Update'
          : 'Play';
    });
    this.scoreForm = this.fb.group({
      PlayerName: ['', Validators.required],
    });
    this.scoreCaptchaForm = this.fb.group({
      captchaCode: ['', Validators.required],
    });

    this._utilsService.getTriggerOfferHistoryObservable().subscribe(() => {
      this.getGameNews();
    });
  }

  updateDisplayedTabs() {
    this.displayMainTabs = this.isMobileScreen
      ? this.mainTabs.slice(0, 2)
      : this.mainTabs;
  }

  toggleShowAllScratch() {
    this.router.navigate(['/dashboard/SectrechCards']);
  }
  checkCurrentRoute() {
    // Get current route path
    const currentUrl = this.router.url;
    const dashboardRoutes = ['/dashboard/home'];
    this.isDashboardPage = dashboardRoutes.some((path) =>
      currentUrl.includes(path),
    );
  }
  visibleGamesCount = 8;
  isDashboardPage: boolean = false;
  @ViewChild('gamesContainer') gamesContainer!: ElementRef;

  showMoreGames() {
    const increment = 4;
    this.visibleGamesCount = Math.min(
      this.visibleGamesCount + increment,
      this.games.length,
    );
  }

  showLessGames() {
    this.visibleGamesCount = 8;
    this.scrollToTop();
  }

  scrollToTop() {
    this.gamesContainer.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  get isToken(): boolean {
    return !!localStorage.getItem('token'); // returns true if token exists, false otherwise
  }

  closeLoginModal() {
    this.showLoginModal = false;
  }

  redirectToSignUp() {
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigate(['/dashboard/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy() {
    if (this.routeSub) this.routeSub.unsubscribe();
  }
  getGameOffers() {
    this.apiCallService
      .GetCallWithoutToken('Public/GetOfferPercentage')
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            const apiGameData = response.data;

            this.games.forEach((game: any) => {
              const matchingOffer = apiGameData?.find(
                (offer: any) => offer.GameName === game.name,
              );

              if (matchingOffer) {
                game.offer = matchingOffer.Percentage;
              }
            });
          } else {
            this.errorHandling.handleResponseError(response);
          }
        },
        error: (error) => {
          this.errorHandling.handleHttpError(error);
        },
      });
  }

  private getInitialVisibleCount(): number {
    try {
      const w = window.innerWidth || 0;
      if (w >= 1900) {
        return 20; // lg
      }
      if (w >= 1200) {
        return 16; // lg
      }
      return 9; // small / default
    } catch (e) {
      return 10;
    }
  }

  // Load more / pagination for featured games
  showAllGames: boolean = true;
  get displayedGames() {
    const sortedGames = [...this.filteredGames].sort(
      (a, b) => b.isHot - a.isHot,
    );
    if (this.showAllGames) return sortedGames;
    const count = this.getInitialVisibleCount();
    return sortedGames.slice(0, count);
  }

  getCustomerID(): number | null {
    return Number(localStorage.getItem('customerId'));
  }
  getCustomerName(): string {
    return localStorage.getItem('userName') || '';
  }

  gameOffers: any;
  getGameOffersWithToken() {
    this._loaderService.show();
    this.apiCallService
      .GetCallWithToken(
        'Offer/GetOfferPercentage?customerId=' + this.getCustomerID(),
      )
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.gameOffers = response.data;
            this._loaderService.hide();
            // Assuming `this.games` is the array where you want to patch the Percentage
            this.games.forEach((game: any) => {
              const matchingOffer = this.gameOffers.find(
                (offer: any) => offer.GameName === game.name,
              );
              // const getPlayerGames = this._loaderService.getArrayInLocalStorage();
              // const matchedGame = getPlayerGames.find(
              //   (matchingGame: any) => matchingGame.GameName === game.name
              // );
              // game.buttonText = matchedGame ? 'Play Now' : 'Add Player';
              if (matchingOffer) {
                game.offer = matchingOffer.Percentage; // Patch the percentage
              }
            });
            this._loaderService.setArrayInLocalStorage(
              'bis_offer',
              this.gameOffers,
            );
          } else {
            this._loaderService.hide();
            this.errorHandling.handleResponseError(response);
          }
        },
        (error) => {
          this._loaderService.hide();
          this.errorHandling.handleHttpError(error);
        },
      );
  }

  loadMoreGames() {
    this.showAllGames = true;
  }

  // Toggle show all / show less
  toggleShowAll() {
    this.showAllGames = !this.showAllGames;
  }

  // whether there are more games than initial visible count
  get hasMoreGames(): boolean {
    return this.filteredGames.length > this.getInitialVisibleCount();
  }
  isMobileScreen: boolean = false;
  isMobile(): boolean {
    return this.isMobileScreen;
  }
  openAddScoreModal(): void {
    this.AddPlayerNameModal = true;
  }
  AddPlayerNameModal: boolean = false;
  closeAddScoreModal(): void {
    this.AddPlayerNameModal = false;
    this.scoreForm.reset();
  }
  gameAccounts: any;

  allowedGames: string[] = [];
  getGameAccount(isAddPlayer: any) {
    const customerID = localStorage.getItem('customerId');

    const payload = 'Game/GetGameUserInfo?CustomerId=' + customerID;
    this.apiCallService.GetCallWithToken(payload).subscribe(
      (response) => {
        if (response && response.responseCode === 200) {
          this.gameAccounts = response.data;
          this._loaderService.setArrayInLocalStorage('bis_data', response.data);
          this.allowedGames = this.gameAccounts.map(
            (game: any) => game.GameName,
          );
          this.games.forEach((game: any) => {
            const getPlayerGames = response.data;
            const matchedGame = getPlayerGames.find(
              (matchingGame: any) => matchingGame.GameName === game.name,
            );
            game.buttonText = matchedGame ? 'Play Now' : 'Play';
            game.IsOnUpdate = matchedGame ? matchedGame.IsOnUpdate : 'False';
          });
          if (isAddPlayer != 0) {
            const gameOffer =
              this._loaderService.getArrayInLocalStorage('bis_offer');
            const matchedGameOffer = gameOffer.find(
              (game: any) => game.GameName === isAddPlayer,
            );
            const matchedGame = this.gameAccounts.find(
              (game: any) => game.GameName === isAddPlayer,
            );
            matchedGame.IsOnUpdate = matchedGameOffer
              ? matchedGameOffer.IsOnUpdate
              : 'False';
            this.OnPlayNow(matchedGame);
          }
        } else {
          this.errorHandling.handleResponseError(response);
        }
      },
      (error) => {
        this.errorHandling.handleHttpError(error);
      },
    );
  }
  gamename: any;
  OnPlayNow(details: any): void {
    this.gamename = details.name;
    if (!this.isToken) {
      this.showLoginModal = true;
      return;
    }

    const matchedGame = this.gameAccounts.find(
      (game: any) =>
        game.GameName === details.name || game.GameName == details.GameName,
    );

    const gameOffer = this._loaderService.getArrayInLocalStorage('bis_offer');
    const matchedGameOffer = gameOffer.find(
      (game: any) =>
        game.GameName === details.name || game.GameName == details.GameName,
    );
    // const specialGames = ['GameVault', 'Juwa', 'Vegas', 'GameRoom'];

    if (matchedGame) {
      matchedGame.IsOnUpdate = matchedGameOffer
        ? matchedGameOffer.IsOnUpdate
        : 'False';
      // Game mil gaya, ab redirect
      localStorage.setItem('GN', matchedGame.GameName);
      this.matchedGameDetails = {
        SerialNumber: matchedGame.SerialNumber,
        PlayerId: matchedGame.PlayerId,
        PlayerName: matchedGame.PlayerName,
        PlayerPassword: matchedGame.PlayerPassword,
        GameName: matchedGame.GameName,
        GameID: matchedGame.GameID,
        IsOnUpdate: matchedGame.IsOnUpdate,
      };

      this.gameService.setGameData(this.matchedGameDetails);
      this.RedirecttoCredentials();
    } else {
      if (matchedGameOffer?.IsOnUpdate === 'True') {
        this.errorHandling.showAlert(
          'warning',
          'Game is under update!. Please try again later.',
        );
        return;
      }
      // Open credentials screen so the user can create an account from the new panel
      localStorage.setItem('GN', details.name);
      this.gameService.setGameData({
        GameName: details.name,
        GameId: details.id,
        IsOnUpdate: matchedGameOffer?.IsOnUpdate || 'False',
      });
      this.RedirecttoCredentials();
    }
  }
  croswsIcon = faXmark;
  AddPlayerModal = false;
  CloseAddPlayer() {
    this.AddPlayerModal = false;
  }
  matchedGameDetails: any = null;
  NewPlayerAddPayload: any = {
    id: 0,
    // customerId: this.getCustomerID(),
    // agentcode: '',
    // t: 0,
    // account: '',
    // nickname: '',
    // rechargeAmount: '',
    // login_pwd: '',
    // check_pwd: '',
    // gameName: '',
    // gameUserID: 0,
    gameName: '',
    customerID: this.getCustomerID(),
    playerUserName: '',
    playerPassword: '',
    rechargeBalance: 0,
    gameId: 0,
  };
  OpenAddPlayer(details: any) {
    this.AddPlayerModal = true;
    this.NewPlayerAddPayload.playerUserName = '';
    this.NewPlayerAddPayload.playerPassword = '';
    // this.NewPlayerAddPayload.t = 0;
    // this.NewPlayerAddPayload.account = '';
    // this.NewPlayerAddPayload.agentcode = '';
    // this.payloadaddnewPlayer(details)
    this.NewPlayerAddPayload.gameName = details.name;
    this.NewPlayerAddPayload.id = details.id;
    this.NewPlayerAddPayload.gameId = details.id;
    this.selectedGameData = details;
  }
  selectedGameData: any;
  RedirectToSpinner() {
    this.router.navigate(['/dashboard/spinner']);
  }
  RedirecttoCredentials() {
    this.router.navigate(['/dashboard/credentials']);
  }

  onTabChange(selectedTab: TabItem) {
    this.selectedMainTab = selectedTab.value;

    // Scroll to the section smoothly
    const target = document.getElementById(selectedTab.scrollingId || '');
    if (target) {
      const offset = 90;

      const elementPosition =
        target.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
  captchaImages: any;
  onPlayerSubmit() {
    this._loaderService.show();
    const payload = this.NewPlayerAddPayload;
    if (payload.playerUserName == '') {
      payload.playerUserName = this.generateGameAccountIdentifier(
        this.getCustomerName(),
        payload.gameName,
      );
    }
    if (payload.playerPassword == '') {
      this.NewPlayerAddPayload.playerPassword = this.generateGameIdentifier(
        payload.gameName,
      );
    }
    if (this.selectedGameData?.IsOnUpdate == 'True') {
      this.errorHandling.showAlert(
        'warning',
        'Game is under update!. Please try again later.',
      );
      return;
    }
    this.apiCallService
      .PostCallWithToken(payload, 'AddGameScore/CreatePanelPlayer')
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.AddPlayerModal = false;
            // this.CloseCaptchaAddPlayer();
            this.getGameAccount(payload.gameName);
            this._loaderService.hide();
          } else {
            this.errorHandling.handleResponseError(response);
            this.AddPlayerModal = false;
            this._loaderService.hide();
          }
        },
        (error) => {
          this.errorHandling.handleHttpError(error);
          this._loaderService.hide();
          this.AddPlayerModal = false;
        },
      );
  }

  generateGameIdentifier(gameId: any): string {
    let prefix: string = this._utilsService.gameNameInitials(gameId);
    const randomDigits = Math.floor(1000 + Math.random() * 9000); // Generates a random 4-digit number
    const randomLetters =
      String.fromCharCode(97 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(97 + Math.floor(Math.random() * 26)); // Generates 2 random lowercase letters

    // return `${prefix}${randomLetters}${randomDigits}`;
    const combined = `${prefix}${randomLetters}${randomDigits}`;
    return combined.charAt(0).toUpperCase() + combined.slice(1); // Ensure first character is uppercase
  }


  //   generateGameAccountIdentifier(CustomerName: string, gameId: any): string {
  //     // 1. Clean the name: Remove anything that isn't a letter or number
  //     let cleanedName = CustomerName.replace(/[^a-zA-Z0-9]/g, () => {
  //       return String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //     });

  //     // --- NEW FIX START ---
  //     // if only numbers
  //     if (/^\d+$/.test(cleanedName)) {
  //       // replce first 2 with alpahbet
  //       const randomChar1 = String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //       const randomChar2 = String.fromCharCode(97 + Math.floor(Math.random() * 26));

  //       cleanedName = randomChar1 + randomChar2 + cleanedName.slice(2);
  //     }
  //     // --- NEW FIX END ---

  //     // Then take the first 5 chars
  //     let prefix: string = cleanedName.slice(0, 5).toLowerCase();

  //     // 2. Pad if shorter than 5
  //     if (prefix.length < 5) {
  //       const charsNeeded = 5 - prefix.length;
  //       for (let i = 0; i < charsNeeded; i++) {
  //         prefix += String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //       }
  //     }

  //     // 3. Get game initials
  //     let gameInitials: string = this._utilsService.gameNameInitials(gameId);

  //     // 4. Generate the 3 random components (2 digits, 1 letter)
  //     const digit1 = Math.floor(Math.random() * 10).toString();
  //     const digit2 = Math.floor(Math.random() * 10).toString();
  //     const letter = String.fromCharCode(97 + Math.floor(Math.random() * 26));

  //     // 5. Place them in an array and shuffle
  //     let components = [digit1, digit2, letter];
  //     for (let i = components.length - 1; i > 0; i--) {
  //       const j = Math.floor(Math.random() * (i + 1));
  //       [components[i], components[j]] = [components[j], components[i]];
  //     }

  //     // 6. Join the shuffled components and return
  //     const randomPart = components.join('');
  //     return `${prefix}${randomPart}${gameInitials}`;
  // }

  generateGameAccountIdentifier(CustomerName: string, gameId: any): string {
    // 1. Clean the name: Replace special characters with random letters
    let cleanedName = CustomerName.replace(/[^a-zA-Z0-9]/g, () => {
      return String.fromCharCode(97 + Math.floor(Math.random() * 26));
    });

    // If username starts with a number,
    // replace first 2 characters with random letters
    if (/^\d/.test(cleanedName)) {
      const randomChar1 = String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );
      const randomChar2 = String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );

      if (cleanedName.length >= 2) {
        cleanedName =
          randomChar1 +
          randomChar2 +
          cleanedName.slice(2);
      } else {
        cleanedName = randomChar1 + randomChar2;
      }
    }

    // Then take the first 5 chars
    let prefix: string = cleanedName.slice(0, 5).toLowerCase();

    // Pad if shorter than 5
    while (prefix.length < 5) {
      prefix += String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );
    }

    // Get game initials
    const gameInitials: string =
      this._utilsService.gameNameInitials(gameId);

    // Generate the 3 random components (2 digits, 1 letter)
    const digit1 = Math.floor(Math.random() * 10).toString();
    const digit2 = Math.floor(Math.random() * 10).toString();
    const letter = String.fromCharCode(
      97 + Math.floor(Math.random() * 26)
    );

    // Shuffle components
    const components = [digit1, digit2, letter];

    for (let i = components.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [components[i], components[j]] = [components[j], components[i]];
    }

    const randomPart = components.join('');

    return `${prefix}${randomPart}${gameInitials}`;
  }

  ///////////////////////////Hitting Hot Games

  HotLottery: any;
  HotSctrach: any;
  HotSpinner: any;
  getGameNews() {
    if (this.isToken) {
      this._loaderService.show();
      this.apiCallService
        .GetCallWithToken('TestImonials/GetHotHittingGames')
        .subscribe(
          (response) => {
            if (response && response.responseCode === 200) {
              this.gameOffers = response.data;
              this._loaderService.hide();
              // Assuming `this.games` is the array where you want to patch the Percentage
              this.games.forEach((game: any) => {
                const matchingOffer = this.gameOffers.find(
                  (offer: any) => offer.GameName === game.name,
                );
                if (matchingOffer) {
                  game.isHot = matchingOffer.IsHot;
                  game.bonus = matchingOffer.Bonus;
                  game.IsOnUpdate = matchingOffer.IsOnUpdate || 'False';
                  if (matchingOffer.GameName === 'Spinner') {
                    this.HotSpinner = matchingOffer.IsHot;
                  } else if (matchingOffer.GameName === 'Lottery') {
                    this.HotLottery = matchingOffer.IsHot;
                  } else if (matchingOffer.GameName === 'ScratchCard') {
                    this.HotSctrach = matchingOffer.IsHot;
                  }
                }
              });
              this._loaderService.setArrayInLocalStorage(
                'bis_offer',
                this.gameOffers,
              );
              this.gameService.triggerUpdatedGames();
            } else {
              this._loaderService.hide();
              // this.errorHandling.handleResponseError(response);
            }
          },
          (error) => {
            this._loaderService.hide();
            // this.errorHandling.handleHttpError(error);
          },
        );
    }
  }
}
